import React, { Component } from "react";
import { Row, Col, Form, Button, Table, Badge } from "react-bootstrap";

/**
 * FormConfigEditor - Add/remove/reorder form fields for a widget instance.
 * Edits the formConfig.fields JSON array.
 *
 * Props:
 *   - fields: Array of field config objects
 *   - onChange: Callback with updated fields array
 */
export default class FormConfigEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: props.fields || [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fields !== this.props.fields) {
      this.setState({ fields: this.props.fields || [] });
    }
  }

  addField = () => {
    const fields = [
      ...this.state.fields,
      { fieldName: "", displayName: "", inputType: "text", required: false, dataField: "", placeholder: "" },
    ];
    this.setState({ fields });
    this.props.onChange && this.props.onChange(fields);
  };

  removeField = (index) => {
    const fields = this.state.fields.filter((_, i) => i !== index);
    this.setState({ fields });
    this.props.onChange && this.props.onChange(fields);
  };

  updateField = (index, key, value) => {
    const fields = [...this.state.fields];
    fields[index] = { ...fields[index], [key]: value };
    this.setState({ fields });
    this.props.onChange && this.props.onChange(fields);
  };

  moveField = (index, direction) => {
    const toIndex = index + direction;
    if (toIndex < 0 || toIndex >= this.state.fields.length) return;
    const fields = [...this.state.fields];
    [fields[index], fields[toIndex]] = [fields[toIndex], fields[index]];
    this.setState({ fields });
    this.props.onChange && this.props.onChange(fields);
  };

  render() {
    const { fields } = this.state;

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <span>
            <strong>Form Fields</strong>{" "}
            <Badge bg="secondary">{fields.length}</Badge>
          </span>
          <Button variant="outline-primary" size="sm" onClick={this.addField}>
            <i className="bi bi-plus me-1"></i>Add Field
          </Button>
        </div>

        <Table size="sm" bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: "30px" }}>#</th>
              <th>Field Name</th>
              <th>Display Name</th>
              <th style={{ width: "110px" }}>Input Type</th>
              <th>Data Field</th>
              <th style={{ width: "60px" }}>Req</th>
              <th style={{ width: "100px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {fields.map((field, index) => (
              <tr key={index}>
                <td className="text-center">{index + 1}</td>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={field.fieldName || ""}
                    onChange={(e) => this.updateField(index, "fieldName", e.target.value)}
                    placeholder="field_name"
                  />
                </td>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={field.displayName || ""}
                    onChange={(e) => this.updateField(index, "displayName", e.target.value)}
                    placeholder="Label"
                  />
                </td>
                <td>
                  <Form.Select
                    size="sm"
                    value={field.inputType || "text"}
                    onChange={(e) => this.updateField(index, "inputType", e.target.value)}
                  >
                    <option value="text">Text</option>
                    <option value="number">Number</option>
                    <option value="email">Email</option>
                    <option value="date">Date</option>
                    <option value="textarea">Textarea</option>
                    <option value="select">Select</option>
                    <option value="password">Password</option>
                    <option value="tel">Phone</option>
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="text"
                    size="sm"
                    value={field.dataField || ""}
                    onChange={(e) => this.updateField(index, "dataField", e.target.value)}
                    placeholder="API field (if different)"
                    title="Field name in API response, if different from fieldName"
                  />
                </td>
                <td className="text-center">
                  <Form.Check
                    type="switch"
                    checked={field.required === true}
                    onChange={(e) => this.updateField(index, "required", e.target.checked)}
                  />
                </td>
                <td>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="me-1"
                    onClick={() => this.moveField(index, -1)}
                    disabled={index === 0}
                  >
                    <i className="bi bi-arrow-up"></i>
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="me-1"
                    onClick={() => this.moveField(index, 1)}
                    disabled={index === fields.length - 1}
                  >
                    <i className="bi bi-arrow-down"></i>
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => this.removeField(index)}
                  >
                    <i className="bi bi-trash"></i>
                  </Button>
                </td>
              </tr>
            ))}
            {fields.length === 0 && (
              <tr>
                <td colSpan="7" className="text-center text-muted py-3">
                  No form fields defined. Click "Add Field" to start.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}
